import { sortByTrending } from './trending';

// Curated wins outright. The block's annotation reads "manually curated and
// ordered, OR can be randomized" — so a curated list is rendered exactly as
// authored, and randomize/limit apply only to the uncurated pool.
// Curation was removed on 2026-09-01: it selected by Builder RECORD id against a
// Builder `braindate` model that was never published, so it could only ever have
// returned an empty list once the block moved to the live feed. The block is
// automated — ordering comes from randomize/trending.
export const selectBraindates = (pool, opts = {}) => {
    const { randomize = false, trending = false, limit = 12, random = Math.random } = opts;
    const entries = pool || [];

    // Trending ranks by engagement and falls back to chronological on ties, so
    // it is a no-op ordering-wise until the event has activity. Randomize wins
    // if both are set — an explicit shuffle is a stronger instruction than a
    // ranking, and the two can't both apply.
    const list = trending && !randomize
        ? sortByTrending(entries)
        : [...entries].sort(
            (a, b) => new Date(a.startDateTime).getTime() - new Date(b.startDateTime).getTime(),
        );

    if (randomize) {
        for (let i = list.length - 1; i > 0; i -= 1) {
            const j = Math.floor(random() * (i + 1));
            [list[i], list[j]] = [list[j], list[i]];
        }
    }

    return list.slice(0, limit);
};
